import {AttachmentCriteria} from '../../../../allkey/framework/parameters/AttachmentCriteria';
import {AttachmentScenario} from '../../../../allkey/framework/parameters/AttachmentScenario';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class BucketCleanerConfiguration extends PredefinedBaseConfiguration {
criteria: AttachmentCriteria;
exitStatusOnSuccess: boolean | null;
scenario: AttachmentScenario;
}

